<script lang="ts">
	import Button from './Button.svelte';
	import Icon from './Icon.svelte';
	import NavigationMyLocation from '@icons/NavigationMyLocation.svelte';
	import AlertWarning from '@icons/AlertWarning.svelte';
	import LoadingCircle from './LoadingCircle.svelte';

	import { getContext } from 'svelte';
	import type { IEventFilterSelectionsStore } from '@stores/eventFilterSelections';
	import type { Writable } from 'svelte/store';
	import { getLocationPromise } from '$lib/geo';

	let className = '';
	export { className as class };

	let isLoading = false;
	let hasErrors = false;

	const eventFilterSelections = getContext<Writable<IEventFilterSelectionsStore>>(
		'eventFilterSelectionsStore'
	);

	async function determineUserLocation() {
		try {
			isLoading = true;
			const location = await getLocationPromise();

			const {
				coords: { latitude, longitude }
			} = location;

			$eventFilterSelections.userLatitude = latitude;
			$eventFilterSelections.userLongitude = longitude;
			$eventFilterSelections.locations = [];
		} catch (e) {
			hasErrors = true;
			console.error(e);
		} finally {
			isLoading = false;
		}
	}

	$: hasLocation = !!($eventFilterSelections.userLatitude && $eventFilterSelections.userLongitude);
</script>

<Button
	variant="secondary"
	class="{className} !h-[3.375rem] !px-3 {hasLocation ? '!text-magenta' : ''} {hasErrors
		? '!text-function-red !border-function-red'
		: ''}"
	on:click={determineUserLocation}
>
	{#if isLoading}
		<LoadingCircle class="mr-1.5" />
	{:else}
		<Icon component={hasErrors ? AlertWarning : NavigationMyLocation} class="mr-1.5" />
	{/if}

	Mein Standort
</Button>
